import React from 'react';
import Box from '../../../shared/Box';
import { ButtonWithHoverAndPress } from '../../../shared/Button';
import Heading from '../../../shared/Heading';
import Icon from '../../../shared/Icon';
import { IntervalSwitch } from '../../../shared/IntervalSwitch';
import { Modal } from '../../../shared/Modal';
import { ModalContentSimple } from '../../../shared/ModalContentSimple';
import Spinner from '../../../shared/Spinner';
import { Statesman } from '../../../shared/Statesman';
import Text from '../../../shared/Text';
import { msToDigital } from '../../../utils';
// @ts-ignore
import styles from './../styles.sass';

interface ITimerProps {
  children: any;
  interval: number;
}
interface ITimerState {
  startTime: any;
  elapsedTimeInMs: number;
}
class Timer extends React.Component<ITimerProps, ITimerState> {
  public state = {
    startTime: new Date(),
    elapsedTimeInMs: 0,
  };
  public componentDidMount() {
    setInterval(() => {
      this.setState(() => ({
        elapsedTimeInMs: new Date().getTime() - this.state.startTime.getTime(),
      }));
    }, this.props.interval);
  }
  public render() {
    return this.props.children({
      elapsedTimeInMs: this.state.elapsedTimeInMs,
    });
  }
}
interface CurrentlyOnCallProps {
  participants: any[];
  onPressLeave: any;
  session: any;
  publisher: any;
  isNetworkConnected: boolean;
  onNetworkReconnected: any;
  onNetworkDisconnected: any;
}

const CurrentlyOnCall = ({
  participants,
  onPressLeave,
  session,
  publisher,
  isNetworkConnected,
  onNetworkReconnected,
  onNetworkDisconnected,
}: CurrentlyOnCallProps) => {
  React.useEffect(() => {
    const audioElement = document && document.querySelector('audio');
    if (audioElement) {
      audioElement.volume = 0;
      audioElement.muted = true;
    }
    window.onunload = () => {
      if (session && publisher) {
        session.unpublish(publisher);
      }
    };
    window.addEventListener('online', onNetworkReconnected);
    window.addEventListener('offline', onNetworkDisconnected);
    window.onbeforeunload = () => {
      return true;
    };
    return function cleanup() {
      window.onbeforeunload = null;
      window.removeEventListener('online', onNetworkReconnected);
      window.removeEventListener('offline', onNetworkDisconnected);
    };
  }, []);

  return (
    <Box
      color="white"
      height="100%"
      display="flex"
      className={styles.wrapper}
      width="100%"
    >
      <Box height="100%" width="100%" color="white">
        <Box width="100%" height="100%">
          <Statesman initialState={{ isShowingLeaveConfirmationModal: false }}>
            {({ isShowingLeaveConfirmationModal }, setState) => (
              <Box
                height="100%"
                className={styles.currentlyOnCallWrapper}
                display="flex"
                direction="column"
              >
                <Box smPaddingTop={24} mdPaddingTop={37} lgPaddingTop={37}>
                  <Box>
                    <Box display="flex" justifyContent="center">
                      <Box display="flex" alignItems="center">
                        {/* 
                        // @ts-ignore */}
                        <IntervalSwitch intervalInMs={1000}>
                          {({ intervalSwitch }: any) => (
                            <Box
                              height={10}
                              width={10}
                              color={intervalSwitch ? '#fd6767' : 'transparent'}
                              shape="circle"
                              marginRight={5}
                            />
                          )}
                        </IntervalSwitch>
                        <Heading
                          color="#292F36"
                          isBold={true}
                          size="md"
                          sizeAtSmScreen="xs"
                        >{`${participants.length} people are recording!`}</Heading>
                      </Box>
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="center"
                      marginTop={24}
                      smMarginTop={20}
                      marginBottom={31}
                      smMarginBottom={20}
                    >
                      <Timer interval={1000}>
                        {({ elapsedTimeInMs }: any) => (
                          <>
                            <Box isHidingAtSmScreen={true}>
                              <Heading
                                dangerouslySetFontSize={60}
                                color="#292F36"
                                align="center"
                              >{`${msToDigital(elapsedTimeInMs)}`}</Heading>
                            </Box>
                            <Box
                              isHidingAtMdScreen={true}
                              isHidingAtLgScreen={true}
                            >
                              <Heading
                                dangerouslySetFontSize={50}
                                color="#292F36"
                                align="center"
                              >{`${msToDigital(elapsedTimeInMs)}`}</Heading>
                            </Box>
                          </>
                        )}
                      </Timer>
                    </Box>
                    <Box display="flex" justifyContent="center">
                      <Box maxWidth={591} width="100%">
                        <Box
                          isHidingAtSmScreen={true}
                          height={2}
                          width="100%"
                          color="#D8D8D8"
                        ></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box
                  smMarginTop={5}
                  mdMarginTop={5}
                  lgMarginTop={24}
                  isFlexChildAndExpandsToAvailableSpace={true}
                  width="100%"
                  height={290}
                >
                  <Box
                    height="100%"
                    display="flex"
                    width="100%"
                    justifyContent="center"
                  >
                    <Box maxWidth={400} width="100%" position="relative">
                      <Box
                        position="absolute"
                        top={true}
                        left={true}
                        width="calc(100% - 4px)"
                        height={20}
                        dangerouslySetInlineStyle={{
                          top: -1,
                          background:
                            'linear-gradient(to bottom, #ffffff, rgba(255, 255, 255, 0))',
                        }}
                      />
                      <Box
                        position="absolute"
                        bottom={true}
                        left={true}
                        width="calc(100% - 4px)"
                        height={20}
                        dangerouslySetInlineStyle={{
                          bottom: -1,
                          background:
                            'linear-gradient(to top, #ffffff, rgba(255, 255, 255, 0))',
                        }}
                      />
                      <div className={styles.participantList}>
                        <Box marginTop={15}>
                          {participants.map(participant => (
                            <Box
                              marginBottom={25}
                              display="flex"
                              smPaddingLeft={41}
                              paddingRight={41}
                            >
                              <Box display="flex" alignItems="center">
                                <Box marginRight={34}>
                                  <Box
                                    shape="circle"
                                    color={
                                      participant.userId
                                        ? '#8940FA'
                                        : participant.deviceKind === 'mobile'
                                        ? '#5499FE'
                                        : participant.deviceKind === 'desktop'
                                        ? '#2CCFB2'
                                        : 'white'
                                    }
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    width={48}
                                    height={48}
                                    smWidth={40}
                                    smHeight={40}
                                  >
                                    {participant.userId ? (
                                      <Box width={23} smWidth={19}>
                                        <Icon
                                          type="anchor_logo"
                                          fillColor="white"
                                        />
                                      </Box>
                                    ) : participant.deviceKind === 'mobile' ? (
                                      <Box width={16} smWidth={13}>
                                        <Icon
                                          type="PhoneIcon"
                                          fillColor="white"
                                        />
                                      </Box>
                                    ) : participant.deviceKind === 'desktop' ? (
                                      <Box width={23} smWidth={19}>
                                        <Icon
                                          type="LaptopIcon"
                                          fillColor="white"
                                        />
                                      </Box>
                                    ) : (
                                      <Box />
                                    )}
                                  </Box>
                                </Box>
                                <Box>
                                  <Box>
                                    <Heading
                                      size="sm"
                                      isBold={true}
                                      color="#292F36"
                                    >
                                      {participant.displayName}
                                    </Heading>
                                  </Box>
                                  <Box>
                                    <Text
                                      size="sm"
                                      isBold={false}
                                      color="#292F36"
                                      maxVisibleLines={1}
                                    >
                                      {participant.podcastName}
                                    </Text>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </div>
                    </Box>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  paddingBottom={26}
                  mdPaddingTop={67}
                  lgPaddingTop={67}
                >
                  <Box maxWidth={300} width="100%">
                    <ButtonWithHoverAndPress
                      isDisabled={false}
                      shape="pill"
                      type="unelevated"
                      colorTheme="black"
                      text="Leave recording"
                      size="md"
                      isFullWidth={true}
                      onPress={() => {
                        setState(() => ({
                          isShowingLeaveConfirmationModal: true,
                        }));
                      }}
                    />
                  </Box>
                </Box>
                <Modal
                  isShowingCloseButton={true}
                  onClickClose={() => {
                    setState(() => ({
                      isShowingLeaveConfirmationModal: false,
                    }));
                  }}
                  isShowing={isShowingLeaveConfirmationModal}
                  renderContent={() => (
                    <Box smPaddingTop={12}>
                      <ModalContentSimple
                        title="Are you sure you want to leave this recording?"
                        renderBody={() => null}
                        primaryButton={{
                          onClick: () => {
                            setState(() => ({
                              isShowingLeaveConfirmationModal: false,
                            }));
                          },
                          text: 'Stay connected',
                        }}
                        secondaryButton={{
                          onClick: () => {
                            onPressLeave();
                          },
                          type: 'unelevated',
                          colorTheme: 'red',
                          text: 'Leave',
                        }}
                      />
                    </Box>
                  )}
                />
                <Modal
                  isShowingCloseButton={false}
                  isShowing={!isNetworkConnected}
                  dialogClassName={styles.modalDialog}
                  renderContent={() => (
                    <ModalContentSimple
                      title="Trying to reconnect..."
                      renderBody={() => (
                        <Box>
                          <Box
                            display="flex"
                            justifyContent="center"
                            marginBottom={20}
                          >
                            <Box width={30}>
                              <Spinner />
                            </Box>
                          </Box>

                          <Text size="md" color="#292F36">
                            If we're unable to reconnect within a few minutes,
                            we'll end the call so you can try again.
                          </Text>
                        </Box>
                      )}
                    />
                  )}
                />
              </Box>
            )}
          </Statesman>
        </Box>
      </Box>
    </Box>
  );
};

export { CurrentlyOnCall };
